var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrosoftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3795_35969)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.4506 29.9982C16.2795 29.9982 13.2653 29.9982 10 29.9982C10 27.0155 9.96864 24.0641 10.0314 21.1128C10.0314 20.8616 10.5652 20.4535 10.8478 20.4221C13.7049 20.3593 16.562 20.3907 19.482 20.3907C19.4506 23.7188 19.4506 26.8585 19.4506 29.9982Z",
    fill: "#5EA3EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9695 10.0938C29.9695 13.2335 29.9695 16.2476 29.9695 19.3559C26.8612 19.3559 23.8156 19.3559 20.6445 19.3559C20.6445 16.3104 20.6445 13.2649 20.6445 10.0938C23.6901 10.0938 26.767 10.0938 29.9695 10.0938Z",
    fill: "#91B82C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6445 29.9343C20.6445 26.7946 20.6445 23.7491 20.6445 20.6094C23.7529 20.6094 26.767 20.6094 29.9067 20.6094C29.9067 23.6863 29.9067 26.7632 29.9067 29.9343C26.924 29.9343 23.847 29.9343 20.6445 29.9343Z",
    fill: "#ECB72C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1562 19.0738C10.1562 16.1538 10.1562 13.2339 10.1562 10.2826C10.2504 10.1884 10.376 10.0942 10.4702 10C13.4216 10 16.3415 10 19.2928 10C19.387 10.0942 19.4812 10.1884 19.544 10.2512C19.544 13.2025 19.544 16.1224 19.544 19.0738C19.4498 19.168 19.3556 19.2936 19.2614 19.3878C16.3415 19.3878 13.3902 19.3878 10.4702 19.3878C10.376 19.2936 10.2818 19.168 10.1562 19.0738Z",
    fill: "#D2512A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5015 10C10.4073 10.0942 10.2817 10.1884 10.1875 10.2826C10.2817 10.1884 10.3759 10.0942 10.5015 10Z",
    fill: "#D04412"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5441 10.2824C19.45 10.1882 19.3558 10.094 19.293 10.0312C19.3872 10.094 19.4814 10.1882 19.5441 10.2824Z",
    fill: "#D04412"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3795_35969"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.9686,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftIcon);
export default __webpack_public_path__ + "static/media/microsoft-icon.33d95b76c8dc2547406651469cd05dec.svg";
export { ForwardRef as ReactComponent };